import { render, staticRenderFns } from "./sales-activity.vue?vue&type=template&id=22131708&scoped=true"
import script from "./sales-activity.vue?vue&type=script&lang=js"
export * from "./sales-activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22131708",
  null
  
)

export default component.exports